import React from 'react'
import { DescText } from '../../../Home/widgets/Banner/BannerComponent.style';
import {
ContainerFluid,HeadingText,Container,ParagraphText,ContainerFluidGrid,ContainerFluidC
,FluidGridA,FluidGridAA,FluidGridB,FluidGridBB
} from './SectionAComponent.style';
function SectionAComponent() {
  return (
    <div>

      <ContainerFluidGrid>
        <Container>
          <div className='row'>
            <div className='col s12 m12 l6'>
              <FluidGridA>
                <br/><br/>
                <br/><br/>
                <div className='spax'
                >
                  
                  <HeadingText>
                    Create a <br/>Saving Plan
                  </HeadingText>
                  <DescText>
                    Or you can check the saving<br/>
                    plan we curated for you to<br/>
                    start saving.<br/>
                  </DescText>
                </div>
                
              </FluidGridA>
              <div className='center hide-on-large-only hide-on-med-only hide-on-small-only show-on-small'>
                  <img width="" className='spax-mob'
                    src='https://res.cloudinary.com/yalla-ng/image/upload/v1663524213/re-brand/Create_Saving_MC_1_rcftf2.svg' alt="" />
              </div>
            </div>
            <div className='col s12 m12 l6'>
              <br class="hide-on-small-only hide-on-med-only" />
              <br class="hide-on-small-only hide-on-med-only" />
              <br class="hide-on-small-only hide-on-med-only" />
              <br class="hide-on-small-only hide-on-med-only" />
              <br class="hide-on-small-only hide-on-med-only" />
              <br class="hide-on-small-only hide-on-med-only" />
              <br class="hide-on-small-only hide-on-med-only" />

              <FluidGridB>
                <br/><br/>
                <br/><br/>
                <div className='spax'
                >
                  <HeadingText>
                    Choose a <br/>
                    Saving Plan
                  </HeadingText>
                  <DescText>
                    Or you can check the saving<br/>
                    plan we curated for you to<br/>
                    start saving.<br/>
                  </DescText>
                </div>
                
              </FluidGridB>
              <div className='center hide-on-large-only hide-on-med-only hide-on-small-only show-on-small'>
                  <img width="" className='spax-mob'
                    src='https://res.cloudinary.com/yalla-ng/image/upload/v1663526900/re-brand/Choose_Plan_MU_1_ljuoe2.svg' alt="" />
              </div>
            </div>
          </div>
        </Container>
      </ContainerFluidGrid>

      <ContainerFluidGrid>
        <Container>
          <div className='row'>
            <div className='col s12 m12 l6'>
              <FluidGridAA>
                <br/><br/>
                <br/><br/>
                <div className='spax'
                >
                  <HeadingText>
                    You have a <br/>
                    goal? Add a <br/>
                    saving target
                  </HeadingText>
                  <DescText>
                    Do you have a long term goal?<br/>
                    Add a saving target to keep<br/>
                    you going.
                  </DescText>
                </div>
                
              </FluidGridAA>
              <div className='center hide-on-large-only hide-on-med-only hide-on-small-only show-on-small'>
                  <img width="" className='spax-mob'
                    src='https://res.cloudinary.com/yalla-ng/image/upload/v1663686144/re-brand/CP_MU_1_b5zm98.svg' alt="" />
              </div>
            </div>
            <div className='col s12 m12 l6'>
              <br class="hide-on-small-only hide-on-med-only" />
              <br class="hide-on-small-only hide-on-med-only" />
              <br class="hide-on-small-only hide-on-med-only" />
              <br class="hide-on-small-only hide-on-med-only" />
              <br class="hide-on-small-only hide-on-med-only" />
              <br class="hide-on-small-only hide-on-med-only" />
              <br class="hide-on-small-only hide-on-med-only" />

              <FluidGridBB>
                <br/><br/>
                <br/><br/>
                <div className='spax'
                >
                  <HeadingText>
                    Add a <br/>
                    payment <br/>
                    method
                  </HeadingText>
                  <DescText>
                    Choose a payment method<br/>
                    you’re convenient with. <br/>
                    Bravo! Your saving plan is <br/>
                    created.
                  </DescText>
                </div>
                
              </FluidGridBB>
              <div className='center hide-on-large-only hide-on-med-only hide-on-small-only show-on-small'>
                  <img width="" className='spax-mob'
                    src='https://res.cloudinary.com/yalla-ng/image/upload/v1663686064/re-brand/Fund_Plan_Mockup_1_e0h2ai.svg' alt="" />
              </div>
            </div>
          </div>
        </Container>
      </ContainerFluidGrid>
          
      
      <ContainerFluidC className=''>
        <Container>
          <div className='row mt-100'>
            <div className='col s12 m12 l7'>
              
              
            </div>
          </div>
        </Container>
      </ContainerFluidC>
    </div>
  )
}

export default SectionAComponent